/**
 * Geografische Grundrechnungen, die Server und Client beide brauchen.
 * Der Server baut in `domain/geo.ts` darauf auf (Antipoden, Großkreispunkte),
 * der Client rechnet damit die zurückgelegte Strecke einer Runde aus.
 */
const EARTH_RADIUS_KM = 6371;
export function toRad(deg) {
    return (deg * Math.PI) / 180;
}
export function toDeg(rad) {
    return (rad * 180) / Math.PI;
}
/** Großkreis-Distanz in km (Haversine). */
export function haversineKm(a, b) {
    const dLat = toRad(b.lat - a.lat);
    const dLon = toRad(b.lon - a.lon);
    const lat1 = toRad(a.lat);
    const lat2 = toRad(b.lat);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
    return 2 * EARTH_RADIUS_KM * Math.asin(Math.min(1, Math.sqrt(h)));
}
//# sourceMappingURL=geo.js.map